
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.375 4.313h1.5a.563.563 0 000-1.125h-1.5a.563.563 0 000 1.124zM5.815 6.375c0 .31.252.563.562.563h5.25a.563.563 0 000-1.125h-5.25a.563.563 0 00-.562.562zM6.375 9.563h5.25a.562.562 0 100-1.126h-5.25a.563.563 0 000 1.126z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.375 7.67L17.9 12c.06.117.093.244.1.375v4.5c0 .621-.504 1.125-1.125 1.125H1.125A1.125 1.125 0 010 16.875v-4.5A1.05 1.05 0 01.105 12l2.52-4.333V1.5a1.5 1.5 0 011.5-1.5h9.75a1.5 1.5 0 011.5 1.5v6.17zm-1.502-5.982a.188.188 0 00-.188-.188h-9.37a.187.187 0 00-.19.188l.01 8.062a.75.75 0 01-1.285.525L1.84 12h3.035C5.496 12 6 12.504 6 13.125s.504 1.125 1.125 1.125h3.75c.621 0 1.125-.504 1.125-1.125S12.504 12 13.125 12h3.038l-1.005-1.725a.75.75 0 01-1.283-.525l-.002-8.063z","fill":"currentColor"}})])
          )
        }
      }
    